import {Button} from "../../../../index";
import React from "react";
import {useViewerStore} from "../../../../../store/store";
import {InputNumber} from "antd";
import {ModuleMesh} from "../../../../../@types/types";
import {updateBallastedRackAngle} from "../../Three-JS-Viewer/Controllers/ModuleControl";

interface UpdateBallastRackingAngleModalProps {
    selectedModules: ModuleMesh[];
}
const UpdateBallastRackingAngleModal = (props:UpdateBallastRackingAngleModalProps) => {


    const [ballastRackingAngle, setBallastRackingAngle] = React.useState<number>(10);

    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const {selectedModules} = props;


    const confirmFinalize = () => {

        selectedModules.forEach(module => {
            const shapeMesh = module.parent
            updateBallastedRackAngle(module, shapeMesh, ballastRackingAngle);
        });

        sceneViewer.viewerAlert({show: false})
    }


    const cancelFinalize = () => {
        sceneViewer.viewerAlert({show: false})
    }


    return (
        <>
            <p>Enter the new racking angle for the selected ballast systems.</p>
            <br/>
            <div className={"modal-bottom-action-button-container"}>

                <label htmlFor={"ballastRackingAngle"}>Ballast Racking Angle : </label>
                <InputNumber
                    min={0}
                    max={90}
                    defaultValue={10}
                    id={"ballastRackingAngle"}
                    value={ballastRackingAngle}
                    onChange={(value) => setBallastRackingAngle(value as number)}
                    formatter={value => `${value}°`}
                />


                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-confirm-button"
                    onClick={confirmFinalize}
                >
                    Confirm
                </Button>
                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-cancel-button"
                    onClick={cancelFinalize}
                >
                    Cancel
                </Button>

            </div>
        </>
    )
}

export default UpdateBallastRackingAngleModal;